import { createApi as user } from './uc/user';
import { createApi as login } from './uc/login';
import { createApi as wechat } from './uc/wechat';
import { createApi as inspirations } from './cc/inspirations';
import { createApi as collections } from './cc/collections';
import { createApi as upload } from './cc/upload';
import { createApi as bailing } from './cc/bailing';
import { createApi as jobs } from './cc/jobs';
import { createApi as feedback } from './cc/feedback';
import { createApi as messages } from './cc/messages';
import { createApi as notify } from './mc';
import { createApi as translations } from './cc/translations';
import { createApi as creations } from './cc/creations';
import { createApi as ops } from './ops/index';
import { createApi as pose } from './cc/pose';
import { createApi as editorPose } from './editor/pose';
import { createApi as editorInpaint } from './editor/inpaint';
import { createApi as editorSr } from './editor/sr';
import { createApi as editorCreation } from './editor/creation';
import { createApi as editorMatting } from './editor/matting';
import { createApi as canvas } from './cc/canvas';
import { createApi as ems } from './ems';
import { createApi as users } from './cc/users';
import { createApi as transactions } from './cc/transactions';
import { createApis as dict } from './dict';
import { createApi as marketing } from './cc/marketing';
import { createApi as article } from './website/articles';
import { createApi as qiye } from './website/qiye';
import { createApi as params } from './cc/params';
import { createApi as psd } from './cc/psd';
import { createApi as aiadQrcode } from './cc/qrcode';
import { createApi as editorCommon } from './cc/common';
import { createApi as pod } from './cc/pod';
import { createApi as batch } from './cc/batch';
import { createApi as fonts } from './graphic-text/fonts';
import { createApi as graphicText } from './graphic-text/index';
import { createApi as graphicTextFission } from './graphic-text/fission';
import { createApi as demo } from './cc/demo';
import { createApi as wordbook } from './cc/wordbook';

export const createApis = {
  user,
  wechat,
  login,
  inspirations,
  collections,
  upload,
  bailing,
  jobs,
  feedback,
  messages,
  notify,
  translations,
  creations,
  ops,
  dict,
  pose,
  editorPose,
  editorInpaint,
  editorSr,
  editorCreation,
  editorMatting,
  canvas,
  ems,
  users,
  transactions,
  marketing,
  article,
  qiye,
  params,
  psd,
  aiadQrcode,
  editorCommon,
  pod,
  batch,
  fonts,
  graphicText,
  graphicTextFission,
  demo,
  wordbook,
};
